import React from 'react';
import { Icon } from './Icon';

const GenderIcon = ({ size }: Props) => {
  return (
    <Icon type="gender-male" color="bg-label-success" size={size} />
  );
}

interface Props {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
}

export { GenderIcon };